import { useTranslation } from "react-i18next";
import styled from "@emotion/styled";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import { DataBlockLayout } from "@rentablo/components";
import { useMyself } from "@api/v1/hooks/useMyself";
import { LOCKED_POINT_CLASS, useChartOptions } from "./useChartOptions";
import type { DateValuePair } from "@rentablo/api/apiv1";

interface Props {
  isFetching?: boolean;
  historicQuotes?: DateValuePair[];
}

const ChartWrapper = styled("div")(({ theme }) => ({
  width: "100%",
  padding: theme.spacing(4),
  paddingTop: theme.spacing(2),
  [`& .${LOCKED_POINT_CLASS}`]: {
    filter: "blur(3px)",
  },
}));

export const HistoricalQuotesBaseChart = ({
  historicQuotes = [],
  isFetching,
}: Props) => {
  const { t } = useTranslation();
  const { data: user, isFetching: isUserLoading } = useMyself();
  const options = useChartOptions({
    historicQuotes,
    isUserPro: !!user?.isUserPro,
    isUserPlus: !!user?.isUserPlus,
  });

  return (
    <DataBlockLayout
      title={t("fundamentals.metrics.historicQuotesPercent.normal")}
      isFetching={isFetching || isUserLoading}
      toolTipData={{
        desc1: t("fundamentals.metrics.historicQuotesPercent.desc"),
      }}
    >
      <ChartWrapper>
        <HighchartsReact highcharts={Highcharts} options={options} />
      </ChartWrapper>
    </DataBlockLayout>
  );
};
